

const initialState = {
   profile: null,
   preferences: null,
   contacts: [],
   channels: [],
   users:{}
  };
  
const userReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'USER_PROFILE':
        return { ...state, profile: action.payload };
      case 'USER_PREFERENCES':
        return { ...state, preferences: action.payload };
      case 'CRM_CONTACTS':
        return { ...state, contacts: action.payload };
      case 'USER_MM_CHANNELS':
        return { ...state, channels: action.payload };
      case 'ADD_USER_INFO':
        return { ...state, users: {...state.users, [action.payload.id]: action.payload} };
      case 'USER_PROFILES_ARRAY':
        const users = state.users;
        action.payload.forEach(profile => {
          users[profile.publicId] = profile;
        });
        return { ...state, users };
      default:
        return state;
    }
  };

  export default userReducer;